<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>国家地区信息维护</span>
      </div>
      <el-form
        ref="userForm"
        :model="countryInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label=" 国家名称：">
            <span>{{ countryInfo.baseDataCountryName }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" 国家名称英文简称：">
            <span>{{ countryInfo.baseDataCountryShortName }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label=" OID编码：">
            <span>{{ countryInfo.baseDataCountryOidCode }}</span>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="着陆页：" prop="baseDataCountryUrl">
            <el-input v-model="countryInfo.baseDataCountryUrl"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过200个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="submit">确定</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      roleOptions: [],
      countryInfo: {
        baseDataCountryId: "",
        baseDataCountryName: "",
        baseDataCountryShortName: "",
        baseDataCountryOidCode: "",
        baseDataCountryUrl: ""
      },
      rules: {
        baseDataCountryUrl: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          },
          {
            max: 200,
            message: "最多输入200个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getCountryInfoById(id) {
      let _this = this;
      let param = {
        url: "/api/country/getCountryInfoById",
        params: {
          baseDataCountryId: id
        }
      };

      _this.$store.dispatch("getCountryInfoById", param).then(() => {
        _this.countryInfo = _this.$store.state.country.countryData.countryInfo;
      });
    },
    submit() {
      let _this = this;
      _this.$refs.userForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/country/updateCountryInfo",
            params: {
              baseDataCountryId: _this.countryInfo.baseDataCountryId,
              baseDataCountryUrl: _this.countryInfo.baseDataCountryUrl
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "国家地区信息维护成功",
                  type: "success"
                });
                this.$router.push({
                  name: "baseDataCountry"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善国家地区信息!",
            type: "warning"
          });
        }
      });
    }
  },
  created() {
    let _this = this;
    let id = this.$route.params.baseDataCountryId;
    if (id !== null && id !== "" && id !== undefined) {
      _this.getCountryInfoById(id);
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
